import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../../../../../../i18n";
import styles from "./LiveEventsTab.module.css";

type LiveEventsTabProps = {
	sessionId: string;
};

export default function LiveEventsTab({ sessionId }: LiveEventsTabProps) {
	return (
		<Stack width="100%" height="100%" spacing="15px">
			<Stack direction="row" spacing="25px">
				<Box width="100%">
					<Typography className={styles.title}>
						{i18n.t("candidate.instructorInterviewPage.inProgress.tabs.live.video")}
					</Typography>
				</Box>
				<Box width="100%">
					<Typography className={styles.title}>
						{i18n.t("candidate.instructorInterviewPage.inProgress.tabs.live.events")}
					</Typography>
				</Box>
			</Stack>

			<iframe
				className={styles.frame}
				src={`${window.location.origin}/live/meet/proctor/liveSession/index.html?sessionId=${sessionId}&popIn=false&candidate=true`}
				allow="microphone; camera"
				height="100%"
				width="100%"
			/>
		</Stack>
	);
}
